import * as React from 'react'
import styles from './styles.module.css'
// import './Skeleton.css'

interface SkeletonTextProps {
  variant: 'text'
  width?: number | String
  height?: number | String
  className?: string
  count?: number | String
  borderRadius?: number | String
  style?: React.CSSProperties
}

interface SkeletonShapeProps {
  variant: 'rect' | 'circle'
  width?: number | String
  height?: number | String
  className?: string
  count?: number | String
  borderRadius?: number | String
  style?: React.CSSProperties
}

type SkeletonProps = SkeletonTextProps | SkeletonShapeProps
export default function VolkenoSkeleton(props: SkeletonProps) {
  let styleProps: React.CSSProperties | any = {}
  if (props.variant) {
    if (typeof props.width === 'string' || typeof props.width === 'number') {
      styleProps.width = props.width
    } else {
      if (props.variant === 'circle') {
        styleProps.width = '100px'
      } else {
        styleProps.width = 'auto'
      }
    }

    if (typeof props.height === 'string' || typeof props.height === 'number') {
      styleProps.height = props.height
    } else {
      styleProps.height = '100px'
    }

    if (
      typeof props.borderRadius === 'string' ||
      typeof props.borderRadius === 'number'
    ) {
      styleProps.borderRadius = props.borderRadius
    } else {
      styleProps.borderRadius = '10px'
    }
  }

  if (props.style) {
    styleProps = {
      ...styleProps,
      ...props.style
    }
  }

  const variantClass = () => {
    let varClass = `Skeleton-${props.variant}`
    if (props.variant === 'text') {
      varClass = styles.SkeletonText
    }
    if (props.variant === 'circle') {
      varClass = styles.SkeletonCircle
    }

    return varClass
  }

  var elements: any = []
  if (props?.count && props.count !== undefined) {
    for (var i = 1; i <= props?.count; i++) {
      elements.push(i)
    }
  } else {
    elements.push(0)
  }

  return (
    <div className={`${styles.SkeletonContainer}`}>
      {elements?.map((_element: number) => (
        <span
          className={`${styles.Skeleton} ${variantClass()} ${
            props.className && props.className !== undefined
              ? props.className
              : ''
          }`}
          style={styleProps}
          key={_element}
        />
      ))}
    </div>
  )
}
